// Video
function enterFS(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  }
}
function exitFS() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}

export const initVideo = () => {
  const video = document.querySelectorAll("video");

  if (!video.length) {
    return;
  }

  video.forEach((elem) => {
    const videoWrapper = elem.closest(".video");
    if (!videoWrapper) {
      return;
    }

    let timeline = videoWrapper.querySelector(".timeline");
    let drag = videoWrapper.querySelector(".timeline__drag");
    let progress = videoWrapper.querySelector(".timeline__progress");
    
    
    function progressiveTimeline(){
      const progressPercentage = (elem.currentTime / elem.duration) * 100;
      drag.style.left = `calc(${progressPercentage}% - 3px)`;
      drag.style.opacity = 1;
      progress.style.width = `${progressPercentage}%`;
    }
    
    elem.addEventListener("play", () => {
      videoWrapper.classList.add('video--play');
      elem.addEventListener("timeupdate",()=>{
        progressiveTimeline();
      });
    });

    elem.addEventListener("pause", () => {  
      videoWrapper.classList.remove('video--play');
    });

    elem.addEventListener('click', ()=> {
      
      if(elem.paused == true){
        elem.play();
      } else {
        elem.pause();
      }    
      elem.addEventListener("timeupdate",()=>{
        progressiveTimeline();
      });
    });

    timeline.addEventListener("click", (e) => {      
      let goToTime = (e.offsetX / timeline.offsetWidth) * elem.duration;
      elem.currentTime = goToTime;
      progressiveTimeline();
    })

    const videoPlay = videoWrapper.querySelector('.video-play');
    if (videoPlay) {
      videoPlay.addEventListener('click', ()=> {
        if (!elem.paused == true) {
          elem.pause();
          videoWrapper.classList.remove('video--play');
        }
        else {
          elem.play();
          videoWrapper.classList.add('video--play');
        }
      });
    }

    const videoMute = videoWrapper.querySelector('.video-sound');
    if (videoMute) {
      videoMute.addEventListener('click', () => {
        videoMute.classList.toggle('video--mute');
        elem.muted = !elem.muted;
      });
    }

    const fullScreen = videoWrapper.querySelector('.video-fullscreen');
    if (fullScreen) {
      const fullToggle = fullScreen.closest('.video');
      fullScreen.addEventListener('click', () => {
        if (fullToggle.className.includes('video')) {
          enterFS(fullToggle);
        } else {
          exitFS();
        }
      });

      fullScreen.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          enterFS(fullToggle);
          elem.setAttribute('controls', 'true');
        }
      });

      fullToggle.addEventListener('fullscreenchange', (event) => {
        if (event.target.className.includes('video--fullscreen')) {
          event.target.classList.remove('video--fullscreen');
        } else {
          event.target.classList.add('video--fullscreen');
        }
      });

      elem.addEventListener('timeupdate', () => {
        const progressPercentage = (elem.currentTime / elem.duration) * 100;
        if (`${progressPercentage}%` == '100%') {
          videoWrapper.classList.remove('video--play');
        }
      });
    }

    elem.dataset.videoInitialized = "1";
  });
};

initVideo();
